import { call, put } from 'redux-saga/effects'
import { fetchLocationUnits } from './apis'
import { setLocationUnits } from './actions'
import { Filter } from 'state/ducks/space/models'

export function* fetchLocationUnitsSaga(action: { type: string; payload: { params: Filter } }) {
  try {
    const res = yield call(fetchLocationUnits, action.payload.params)
    yield put(setLocationUnits(res))
  } catch (e) {
    // error handling (必要に応じて実装)
  }
}
